import { themeChakra } from '@wow/themes'
import info from '../../assets/images/info.svg'

const toastStyle = {
    toastError: {
        display: 'inline-flex',
        color: 'white',
        minWidth: '480px',
        maxWidth: '1280px',
        padding: '16px 48px',
        alignItems: 'center',
        margin: '0 0 40px 40px',
        gap: '8px',
        boxShadow: themeChakra.shadows.md,
        borderRadius: '8px',
        backgroundColor: themeChakra.colors.error[100],
        backgroundImage: `url(${info})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left',
        backgroundOrigin: 'padding-box',
        backgroundPositionX: '16px',
    }
}

export default toastStyle